import React from 'react'
import {Icon} from '@therms/atalaya'
import {MobileMenuLink} from '@src/modules/Layout/shared/MobileMenuLink'
import {USERS_ROUTES} from '../../constants'
import {FaUsers} from 'react-icons/fa'

function UsersMobileMenuLink() {
  return (
    <MobileMenuLink to={USERS_ROUTES.__ROOT__}>
      <div className="flex flex-col items-center">
        <Icon Icon={FaUsers} />
        <span>Roster</span>
      </div>
    </MobileMenuLink>
  )
}

export {UsersMobileMenuLink}
